import type { Domain } from "@xinghai/shared";
import { DOMAIN_LABEL } from "../labels";

export function AnnotatorGuide({ domain }: { domain: Domain }) {
  return (
    <details className="xz-guide">
      <summary>新手教学：我到底要做什么？（点击展开）</summary>
      <ol>
        <li><b>先听完整条。</b> 不要听到一个字就急着打分，因为后面的语气和节奏会影响判断。</li>
        <li><b>再看目标字。</b> 把录音和屏幕上的字逐个对照；标记告诉系统“哪里不一样”。</li>
        <li><b>最后拖评分。</b> 0 是明确错误，1 是完全清楚；拿不准就留空并写备注，空白不是 0。</li>
        <li><b>为什么要这样做？</b> 逐字标记让 AI 知道错在哪里，句级评分让老师知道整体听感；两者不能互相代替。</li>
        <li><b>提交前检查。</b> 朗读看声母/韵母/声调；歌唱看字头/字腹/字尾。歌唱不填声调。</li>
      </ol>
      <p className="gz-caption">当前任务：{DOMAIN_LABEL[domain]}。系统会把两位专家的结果自动合并；分歧大时交给仲裁，不需要你猜另一位专家的答案。</p>
    </details>
  );
}
